import { memo } from "react";
import Markdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

interface ChatMessageMarkdownProps {
  content: string;
}

const components: Components = {
  a: ({ children, href, title }) =>
    href ? (
      <a
        href={href}
        title={title}
        target={href.startsWith("#") ? undefined : "_blank"}
        rel="noopener noreferrer nofollow"
      >
        {children}
      </a>
    ) : (
      <span>{children}</span>
    ),
  img: ({ alt }) => (
    <span className="italic">[Image not loaded{alt ? `: ${alt}` : ""}]</span>
  ),
  pre: ({ children }) => (
    <pre tabIndex={0} role="region" aria-label="Code block">
      {children}
    </pre>
  ),
  table: ({ children }) => (
    <div
      className="chat-message-markdown-table"
      tabIndex={0}
      role="region"
      aria-label="Message table"
    >
      <table>{children}</table>
    </div>
  ),
};

export const ChatMessageMarkdown = memo(function ChatMessageMarkdown({
  content,
}: ChatMessageMarkdownProps) {
  return (
    <div className="chat-message-markdown">
      <Markdown components={components} remarkPlugins={[remarkGfm]} skipHtml>
        {content}
      </Markdown>
    </div>
  );
});
